var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"mb-auto px-3 py-1",attrs:{"pill":"","variant":_vm.v.variant}},[_vm._v(_vm._s(_vm.v.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }